import React, { useState, useMemo, useContext, useEffect } from 'react';
import { Layout } from './Layout';
import { MetricCard } from './MetricCard';
import { AppContext } from '../src/App';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from './ui/breadcrumb';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Badge } from './ui/badge';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from './ui/alert-dialog';
import { Progress } from './ui/progress';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import {
  Home,
  Play,
  FileText,
  CheckCircle,
  AlertCircle,
  Clock,
  Eye,
  Download,
  Database,
  Bot,
  Timer,
  Activity,
  BarChart3,
  RefreshCw,
  Loader2,
  MousePointer,
  ChevronLeft,
  ChevronRight,
  Upload,
  MoreHorizontal,
  Edit,
  TestTube,
  Code,
  Copy,
  Trash2,
  FileCheck2,
  CircleCheckBig,
  Check,
  ChevronsUpDown,
  ChartColumn,
  RotateCcw,
  Undo,
  BarChart3Icon,
  SquareArrowUp,
  Archive,
  ArchiveRestore,
} from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from './ui/dialog';
import { toast } from 'sonner';
import { useAuth } from './AuthContext';
import { cn } from './ui/utils';
import { apiClient } from '../src/Utils/apiClient';
import { PaginationCustom } from './ui/pagination-custom';
import { downloadHarvestIdJSON, downloadHarvestZip, downloadBatchHarvestZip, triggerDownload } from './ui/downloadHelpers';
import { Checkbox } from './ui/checkbox';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from './ui/dropdown-menu';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from './ui/command';
import { errorResponse } from '@/Utils/helpers';
import { Label } from './ui/label';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes/config';



// Generate mock harvest data
const generateMockHarvestData = (data?: any) => {
  const runs = [];
  const statuses = ['Completed', 'In Progress', 'Failed', 'Pending'];
  const sources = ['Epic MyChart', 'Cerner HealthLife', 'Allscripts', 'NextGen', 'athenaHealth'];



  for (let i = 1; i <= 25; i++) {
    const totalCharts = Math.floor(Math.random() * 500) + 100; // 100-600 charts
    const passed = Math.floor(totalCharts * (0.6 + Math.random() * 0.3)); // 60-90% pass rate
    const failed = Math.floor(totalCharts * (0.05 + Math.random() * 0.15)); // 5-20% fail rate
    const needsReview = totalCharts - passed - failed;

    // Ensure we have mostly completed runs for testing
    const status = i <= 20 ? 'Completed' : statuses[Math.floor(Math.random() * statuses.length)];
    const scrapeTime = Math.floor(Math.random() * 300) + 120; // 2-7 minutes
    const aiTime = Math.floor(Math.random() * 180) + 60; // 1-4 minutes

    runs.push({
      id: `HR-${String(i).padStart(4, '0')}`,
      status,
      source: sources[Math.floor(Math.random() * sources.length)],
      executedAt: new Date(Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000), // Last 30 days
      totalCharts,
      chartsPassed: passed,
      chartsFailed: failed,
      chartsNeedingReview: needsReview,
      scrapeTimeSeconds: scrapeTime,
      aiTimeSeconds: aiTime,
      totalTimeSeconds: scrapeTime + aiTime,
      progress: status === 'In Progress' ? Math.floor(Math.random() * 80) + 10 : 100,
    });
  }

  return runs.sort((a, b) => b.executedAt.getTime() - a.executedAt.getTime());
};

// const harvestRuns = generateMockHarvestData();

// Format duration from seconds to readable format
const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins} min ${secs} s`;
};



export function ChatHarvest() {
  const { user, token } = useAuth();
  const { sideBarItems, setCurrentView, setSelectedHarvestRunData, pagination, setPagination, orgConfig } = useContext(AppContext);
  const [showRunDialog, setShowRunDialog] = useState(false);
  const [selectedRun, setSelectedRun] = useState<any>(null);
  const [isRunning, setIsRunning] = useState(false);
  const [harvestRuns, setHarvestRuns] = useState([])
  const [currentPage, setCurrentPage] = useState(pagination?.chartReview || 1);
  const [paginationData, setPaginationData] = useState<any>()
  const [selectedCategory, setSelectedCategory] = useState<any>();
  const [dropdownVal, setDropdownVal] = useState<any>();
  const [typeOfRun, setTypeOfRun] = useState<number>(2);
  const [selectedBatchFile, setSelectedBatchFile] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [updateKT, setUpdateKT] = useState(false)
  const [isDownloading, setIsDownloading] = useState(false)
  const [loading, setLoading] = useState(false);
  const [showArchived, setShowArchived] = useState(false);
  const navigate = useNavigate();

  const chartReviewMenu = sideBarItems.find((item: any) => item.name === "Chart Review");
  const hasChartPermission = (permission: string) => {
    return chartReviewMenu?.userPermissions?.includes(permission);
  }

  const isAdmin = user?.roles?.some(
    (role: any) => role.toLowerCase() === 'admin' || role.toLowerCase() === 'super_admin'
  );
  const isAdmins: boolean = false
  console.log(token, "tokenInChart")

  const tableHeaders = [
    { label: "BATCH ID", className: "w-24" },//AUDIT BATCH DETAILS
    { label: "RUN DATE", className: "w-24", }, // DATE
    { label: "RUN TIME", className: "w-24" }, // TIME
    { label: "STATUS", className: "w-24", conditional: hasChartPermission("chart:create") }, // STATUS
    { label: "CHART TYPE", className: "w-24", lableClassName: "text-center" },
    { label: "EXECUTION TIME", conditional: isAdmins },//Execution Time
    { label: "CHARTS IN BATCH", className: "w-24", lableClassName: "text-center" }, //Total Number of Charts in Batch
    { label: "Chart(s) Review Needed", className: "w-24", lableClassName: "text-center" },//Total Chart To Be Reviewed by Auditor
    { label: "CHART(S) REVIEWED", className: "w-24", lableClassName: "text-center" },//Total Charts Reviewed by Auditor
    { label: "CHART(S) PENDING ACTION", className: "w-24", lableClassName: "text-center" },
    { label: "CHART(S) UPDATED", className: "w-24", lableClassName: "text-center" },
    { label: "CHART(S) NO ACTION", className: "w-24", lableClassName: "text-center" },
    { label: "REVIEW", className: "w-24", conditional: isAdmins },//REVIEW
    { label: "Agreed", className: "w-24", conditional: isAdmins },
    { label: "Dis-Agreed", className: "w-24", conditional: isAdmins },
    { label: "Failed", className: "w-24", conditional: isAdmins },
    { label: "Scrape Time", conditional: isAdmins },
    { label: "AI Time", conditional: isAdmins },
    { label: "Total Time", conditional: isAdmins },
    { label: "", className: "w-16", conditional: isAdmins },
    { label: "ACTION", className: "w-24 text-center" },
    // { label: "APPROVE", className: "w-24 text-center", conditional: isAdmin }
  ];


  // Get only the last 10 harvest runs for display
  // const recentHarvestRuns = useMemo(() => {
  //   return harvestRuns?.slice(0, 10);
  // }, [harvestRuns]);

  const itemsPerPage = 15;

  const totalItems = paginationData?.totalCount || harvestRuns.length;
  console.log(totalItems)
  const totalPages = paginationData?.totalPages || Math.ceil(harvestRuns.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  //for dropdown menu
  type DateGroup = 'today' | 'yesterday' | 'thisWeek' | 'thisMonth' | 'others' | 'lastMonth';

  interface BatchFile {
    id: string;
    name: string;
    fullName: string;
  }

  interface BatchGroups {
    today: BatchFile[];
    yesterday: BatchFile[];
    thisWeek: BatchFile[];
    thisMonth: BatchFile[];
    lastMonth: BatchFile[];
    others: BatchFile[];
  }
  const fetchData = async () => {
    setLoading(true);
    try {
      const runsParams: { page: any; limit: number; archive?: boolean } = { page: currentPage, limit: 15 }
      if (showArchived) {
        runsParams.archive = true;
      }
      const response = await apiClient('harvest/runs', {
        method: 'GET',
        token,
        queryParams: runsParams,
      });

      const DropdownResponse = await apiClient(`harvest/runs/type `, {
        method: 'GET',
        token,
      });


      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Request failed');
      }
      if (DropdownResponse.ok) {
        const Dddata = await DropdownResponse.json();
        const batchFiles = buildBatchFiles(Dddata?.data?.harvestRunType);
        setDropdownVal(batchFiles || {});
        // setDropdownVal(Dddata?.data?.harvestRunType ? Dddata?.data?.harvestRunType : {})
      }

      // const newData = await generateMockHarvestData(data)
      setHarvestRuns(data?.data?.harvestRuns)
      setPaginationData(data?.data?.pagination)

      return data;
    } catch (error: any) {
      console.error('Fetch error:', error.message);
      return null;
    }
    finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchData()

    //  return () => setCurrentPage(1);
    // setCurrentPageHarvestRuns(1);

  }, [currentPage, showArchived])

  const handleArchiveBatch = async (harvestId: String) => {
    try {
      if (!harvestId) return;
      const response = await apiClient(`harvest/runs/${harvestId}/archive`,
        {
          method: 'PUT',
          token
        });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || 'Request failed');
      }
      if (response.ok) {
        toast.success(data.message || 'Harvest run successfully archived')
        fetchData()
      }
    } catch (error: any) {
      console.error('Fetch error:', error.message);
      toast.error(error.message || 'Bad request. Could not archive.');
      return null; // Add this return statement
    }
    return null; // Add a return statement here as well
  };

  const handleDownloadLog = async (runName: string) => {
    if (!runName) {
      toast.error("Cannot download log, run name is missing.");
      return;
    }

    try {

      const response = await apiClient(`harvest/logs/download/runs/${runName}`, {
        method: 'GET',
        token
      });

      if (!response.ok) {
        const errText = await response.text(); // read raw
        try {
          const errJson = JSON.parse(errText);
          throw new Error(errJson.error || "Failed to download log");
        } catch {
          throw new Error("Failed to download log");
        }
      }

      // Success → read as blob
      const blob = await response.blob();

      const filename = `${runName}.txt`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

    } catch (error: any) {
      console.error("Download error:", error);
      toast.error(error.message || "Could not download log.");
    }
  };


  // console.log("Harvest Runs :", harvestRuns);

  function getDateGroup(dateStr: string): DateGroup | null {
    const today = new Date();
    const inputDate = new Date(
      `${dateStr.slice(0, 4)}-${dateStr.slice(4, 6)}-${dateStr.slice(6, 8)}`
    );

    const diffTime = today.getTime() - inputDate.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays < 1 && today.getDate() === inputDate.getDate()) return "today";
    if (diffDays < 2 && today.getDate() - inputDate.getDate() === 1) return "yesterday";

    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());

    if (inputDate >= startOfWeek) return "thisWeek";

    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    if (inputDate >= startOfMonth) return "thisMonth";
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0); // last day of prev month

    if (inputDate >= lastMonthStart && inputDate <= lastMonthEnd) {
      return "lastMonth";
    }

    return null;
  }


  function extractDateAndType(str: string): { date: string; id: string; fullName: string } | null {
    const dateRegex = /\d{8}/;
    //  /(\d{8})/g
    const matches = str.match(dateRegex);
    // const typeRegex = /(CSC|DLS|EMR|WKL|RPT|AUD|MTH|EOW|BAK|QTR)/;

    if (matches) {
      const date = matches[matches.length - 1];
      // const typeMatch = str.match(typeRegex);
      // const type = typeMatch ? typeMatch[1] : "GEN";
      const id = str;
      const fullName = str;
      return { date, id, fullName };
    }

    return null;
  }

  // function buildBatchFiles(inputList: string[]): BatchGroups {
  //   const result: BatchGroups = {
  //     today: [],
  //     yesterday: [],
  //     thisWeek: [],
  //     thisMonth: [],
  //     others: []
  //   };

  //   const idTracker = new Set<string>(); // Track duplicate IDs

  //   for (let i = 0; i < inputList?.length; i++) {
  //     const item = inputList[i];
  //     const parsed = extractDateAndType(item);

  //     let id: string;
  //     let name: string;
  //     let fullName: string;

  //     if (parsed) {
  //       // Ensure unique ID by appending a count if needed
  //       id = parsed.id;
  //       while (idTracker.has(id)) {
  //         id = `${parsed.id}_${i}`; // Add index to avoid duplicates
  //       }
  //       idTracker.add(id);
  //       name = parsed.id;
  //       fullName = parsed.fullName;

  //       const group = getDateGroup(parsed.date);
  //       if (group && result[group]) {
  //         result[group].push({ id, name, fullName });
  //       } else {
  //         result.others.push({ id, name, fullName });
  //       }
  //     } else {
  //       id = `${item}`; // Even non-matching entries should be unique
  //       name = item;
  //       fullName = item;
  //       result.others.push({ id, name, fullName });
  //     }
  //   }

  //   return result;
  // }
  //new filter
  function buildBatchFiles(inputList: string[]): BatchGroups {
    const result: BatchGroups = {
      today: [],
      yesterday: [],
      thisWeek: [],
      thisMonth: [],
      lastMonth: [],
      others: []
    };

    const seen: Record<string, number> = {};

    for (let i = 0; i < inputList?.length; i++) {
      const item = inputList[i];
      const parsed = extractDateAndType(item);

      let id: string;
      let name: string;
      let fullName: string;
      let key: string;

      if (parsed) {
        id = parsed.id;   // keep original
        name = parsed.id;
        fullName = parsed.fullName;

        // only for React key uniqueness
        seen[id] = (seen[id] || 0) + 1;
        key = seen[id] > 1 ? `${id}_${seen[id]}` : id;

        const group = getDateGroup(parsed.date);
        if (group && result[group]) {
          result[group].push({ key, id, name, fullName });
        } else {
          result.others.push({ key, id, name, fullName });
        }
      } else {
        id = item;
        name = item;
        fullName = item;

        seen[id] = (seen[id] || 0) + 1;
        key = seen[id] > 1 ? `${id}_${seen[id]}` : id;

        result.others.push({ key, id, name, fullName });
      }
    }

    return result;
  }
  // Calculate KPI metrics (use all runs for accurate metrics)
  const kpiMetrics = useMemo(() => {
    const totalCharts = harvestRuns.reduce((sum, run: any) => sum + run.totalCharts, 0);
    const chartsPassed = harvestRuns.reduce((sum, run: any) => sum + run.chartsPassed, 0);
    const chartsNeedingReview = harvestRuns.reduce((sum, run: any) => sum + run.chartsNeedingReview, 0);
    const chartsFailed = harvestRuns.reduce((sum, run: any) => sum + run.chartsFailed, 0);

    const avgScrapeTime = harvestRuns.length > 0
      ? harvestRuns.reduce((sum, run: any) => sum + run.scrapeTimeSeconds, 0) / harvestRuns.length
      : 0;

    const avgAiTime = harvestRuns.length > 0
      ? harvestRuns.reduce((sum, run: any) => sum + run.aiTimeSeconds, 0) / harvestRuns.length
      : 0;

    // Calculate trends (mock data for demonstration)
    const chartsScrapedTrend = {
      percentage: Math.random() * 20 + 5, // 5-25% increase
      isPositive: true,
      hasData: true,
    };

    const chartsPassedTrend = {
      percentage: Math.random() * 15 + 2, // 2-17% increase
      isPositive: true,
      hasData: true,
    };

    const chartsReviewTrend = {
      percentage: Math.random() * 10 - 5, // -5% to +5%
      isPositive: Math.random() > 0.5,
      hasData: true,
    };

    const chartsFailedTrend = {
      percentage: Math.random() * 8 - 4, // -4% to +4%
      isPositive: Math.random() < 0.3, // Usually negative is good for failed charts
      hasData: true,
    };

    const scrapeTrend = {
      percentage: Math.random() * 10 - 5, // -5% to +5%
      isPositive: Math.random() > 0.6, // Faster is better
      hasData: true,
    };

    const aiTrend = {
      percentage: Math.random() * 8 - 4, // -4% to +4%
      isPositive: Math.random() > 0.6, // Faster is better
      hasData: true,
    };

    return {
      totalCharts,
      chartsPassed,
      chartsNeedingReview,
      chartsFailed,
      avgScrapeTime: formatDuration(Math.floor(avgScrapeTime)),
      avgAiTime: formatDuration(Math.floor(avgAiTime)),
      trends: {
        chartsScrapedTrend,
        chartsPassedTrend,
        chartsReviewTrend,
        chartsFailedTrend,
        scrapeTrend,
        aiTrend,
      }
    };
  }, []);

  const handleRunHarvest = () => {
    if (hasChartPermission("chart:create")) {
      setShowRunDialog(true);
    } else {
      toast.error("You do not have permission to run a file.");
    }

  };

  const handleDownload = (harvestId: string) => {
    downloadHarvestZip({ id: harvestId, token });
  };
  const handleBatchDownload = (harvestId: string, chartId: string, runFlag: number) => {
    downloadBatchHarvestZip({ id: harvestId, token, chartId, runFlag });
  };
  // const handleViewRunLog = (runData: any) => {
  //   // console.log('View run log clicked for run:', runData);
  //   setSelectedHarvestRunData(runData);
  //   setCurrentView('batch-run-log-view')
  // }
  const handleComparePerformance = (runData: any) => {
    setSelectedHarvestRunData(runData);
    setCurrentView('audit-decision-comparison');
  }
  const confirmRunHarvest = async () => {

    try {
      setIsRunning(true);

      const response = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs?type=${selectedBatchFile || "APPROVED"}&runFlag=${typeOfRun}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        // body: JSON.stringify(dataToSend)
      });

      const data = await response.json();

      if (!response.ok) {
        toast.error(data?.message || 'Batch Run Failed');
        throw new Error(data.error || 'Request failed');
      }

      const runId = data?.harvestId;
      const pollInterval = 2000;
      const intervalId = setInterval(async () => {
        try {
          const statusResponse = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs/status/${runId}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
          });
          const statusData = await statusResponse.json();
          if (statusData?.status === 'FAILED') {
            clearInterval(intervalId);
            await fetchData();
          }

          if (statusData?.status === 'COMPLETED') {
            clearInterval(intervalId);
            toast.success('Batch run completed');
            await fetchData(); // call your data fetcher
          }
        } catch (err) {
          console.error('Polling error:', err);
          // toast.error(err?.message);
          clearInterval(intervalId); // Optional: stop polling on error
        }
      }, pollInterval);

      return data;
      // const newData = await generateMockHarvestData(data)
      return data;
    } catch (error: any) {
      setIsRunning(false);
      // console.log(error.messagge,"33333")
      // toast.error("Batch run Failed");
      return null;
    } finally {
      setIsRunning(false);
      setShowRunDialog(false);
      setSelectedBatchFile(null);
      await fetchData()
    }
    // setIsRunning(true);
    // setShowRunDialog(false);

    // // Simulate harvest run
    // toast.success('Harvest run initiated successfully', {
    //   description: 'The system is now extracting and processing chart data.',
    // });

    // // Simulate completion after 5 seconds
    // setTimeout(() => {
    //   setIsRunning(false);
    //   toast.success('Harvest run completed', {
    //     description: 'Successfully processed 247 charts with AI evaluation.',
    //   });
    // }, 5000);
  };
  const handleApproveHarvest = async (runId: string) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs/status/${runId}?status=Approved`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await response.json();
      console.log(data, "selected data")
      if (data?.success) {
        toast.success('Sent to Audit Queue successfully', {
          description: `Run has been sent to audit queue.`,
        });
        await fetchData(); // Refresh data after approval
      }
      return data;
    } catch (error: any) {
      console.error('Approve Harvest error:', error);
      return null;
      // alert(`Approval failed: ${error.message}`);

    } finally {
      setSelectedRun(null)
    }
  }
  const hanldeUnApproeveHarvest = async (runId: string) => {
    try {
      const response = await fetch(`${import.meta.env.VITE_API_URL}harvest/runs/status/${runId}?status=Pending`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await response.json();
      if (data?.success) {
        toast.success('Returned from Audit Queue successfully', {
          description: `Run has been returned from audit queue.`,
        });
        await fetchData(); // Refresh data after approval
      }
      return data;
    } catch (error: any) {
      console.error('Approve Harvest error:', error);
      return null;
      // alert(`Approval failed: ${error.message}`);

    } finally {
      setSelectedRun(null)
    }

  }

  // const getRunIdentifier = (run: any) =>
  //   run?.run_id || run?.id || run?.harvest_run_id || run?.display_harvest_id;

  const handleViewRunLog = (run: any) => {
    setSelectedHarvestRunData(run);
    setCurrentView('batch-run-log-view'); // Keep for legacy/safeguard

    // Navigate using the new route
    navigate(ROUTES.chartReviewLog(run.display_harvest_id || run.run_id), {
      state: { selectedHarvestRunData: run }
    });
  };

  const handleRowClick = (run: any) => {
    console.log('Row clicked:', run);
    console.log('Run status:', run.status);

    // Only allow navigation for completed runs
    if (run.status === 'COMPLETED' || run.status === 'FAILED' || run.status === 'PARTIAL') {
      console.log('Setting selected harvest run data:', run);
      setSelectedHarvestRunData(run);
      console.log('Navigating to harvest-run-detail view');
      setCurrentView('harvest-run-detail');

      navigate(ROUTES.chartReviewRun, {
        state: { harvesRun: run }
      });
    } else {

      toast.info(`Cannot view details for ${run.status.toLowerCase()} runs`, {
        description: 'Only completed chart review runs can be viewed in detail.',
      });
    }
  };

  const getStatusBadge = (status: string) => {
    const statusConfig = {
      'COMPLETED': { color: 'bg-green-100 text-green-800 border-green-200 ', icon: CheckCircle },
      'In Progress': { color: 'bg-blue-100 text-blue-800 border-blue-200', icon: Loader2 },
      'Failed': { color: 'bg-red-100 text-red-800 border-red-200', icon: AlertCircle },
      'Pending': { color: 'bg-yellow-100 text-yellow-800 border-yellow-200 ', icon: Clock },
      'Partial': { color: 'bg-gray-100 text-gray-800 border-gray-200 ', icon: Clock }
    };

    const config = statusConfig[status as keyof typeof statusConfig] || statusConfig['Pending'];
    const IconComponent = config.icon;

    return (
      <Badge variant="outline" className={`${config.color} gap-1 text-sm font-medium`}>
        <IconComponent className={`w-3 h-3 ${status === 'In Progress' ? 'animate-spin' : ''}`} />
        {status}
      </Badge>
    );
  };


  const onPageChange = (page: number) => {
    // console.log(page,"qwertyuio")
    setCurrentPage(page);
    setPagination(prev => ({
      ...prev,
      chartReview: page
    }))
    // setCurrentPageHarvestRuns(page)
  };
  const handleUpdateKantTime = async () => {
    try {
      const body = {
        "UIUpdate": true
      }
      const response = await apiClient('audits/charts/update/ui/kt', {
        method: 'POST',
        token,
        body
      })
      const result = await response.json()
      if (result?.success) {
        // console.log(result)
        toast.success(result?.message)
        await fetchData();

      }
      else {
        throw new Error(result?.message)
      }

    } catch (error) {
      // console.log(error)
      const errMsg = errorResponse(error)
      toast.error(errMsg)

    }
    finally {
      setUpdateKT(false)
    }
  }
  // download BatchFile detail after seleceted batch 
  const handleDownloadPreBatch = async () => {
    try {
      setIsDownloading(true)
      const response = await apiClient(`harvest/runs/download/:id?fileName=${selectedBatchFile}`, {
        method: "GET",
        token
      });
      const result = await response.json();
      triggerDownload(result, `${selectedBatchFile}.json`)
      // toast.success("Successfully Batch File Downloaded")

    }
    catch (err: any) {
      const errMsg = errorResponse(err);
      toast.error(errMsg);


    }
    finally {
      setIsDownloading(false)
    }
  }
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-white">
        <div className="p-8">
          {/* Breadcrumb Navigation */}
          <div className="mb-6">
            <Breadcrumb>
              <BreadcrumbList>
                {/* <BreadcrumbItem>
                  <BreadcrumbLink href="#" onClick={() => setCurrentView('dashboard')} className="flex items-center gap-2">
                    <Home className="w-3 h-3" />
                    Dashboard
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator /> */}
                <BreadcrumbItem>
                  <BreadcrumbPage><div className='flex items-center gap-2'> <BarChart3Icon className="w-4 h-4" />  Chart Review</div> </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>

          {/* Header with Run Harvest Button */}
          <div className={`flex items-center justify-between mb-8`}>
            <div className='mr-2'>
              <h1 className="font-inter font-semibold text-2xl leading-[100%] tracking-[0]  mb-2">
                Chart Review Dashboard
              </h1>
              <p className="font-inter font-normal text-[16px] leading-[20px] tracking-normal">
                {/* Monitor chart extraction runs, track AI evaluation performance, and manage automated data batch processes. */}
                Monitor chart processing batches and track review progress.
              </p>
            </div>

            {/* <div> {isAdmin && }</div> */}

            <div className="flex items-center gap-3">
              {/* {hasChartPermission("audits:review") && (
                <Button onClick={() => { setUpdateKT(true) }} className='bg-blue-500 hover:bg-blue-600'>{`Update ${orgConfig.name}`}</Button>)} */}
              {hasChartPermission("chart:create") && (
                <>
                  <div className="flex items-center space-x-2 border border-gray-300 rounded-md p-2">
                    <Checkbox
                      id="show-archived"
                      checked={showArchived}
                      onCheckedChange={(checked => {
                        setShowArchived(checked == true)
                      })}
                    />
                    <Label
                      htmlFor="show-archived"
                      className="text-sm font-normal text-gray-700">
                      Include Archived Batches
                    </Label>
                  </div>

                  {/* Batch File Selector */}
                  <div className="min-w-64">
                    <Popover open={open} onOpenChange={setOpen}>
                      <PopoverTrigger asChild>
                        <Button
                          variant="outline"
                          role="combobox"
                          aria-expanded={open}
                          className="w-full justify-between text-left font-normal bg-white border-gray-300 hover:border-gray-400 focus:border-blue-500 focus:ring-blue-500"
                        >
                          {selectedBatchFile
                            ? Object.values(dropdownVal)?.flat()?.find((file) => file?.id === selectedBatchFile)?.name
                            : "Select batch file..."}
                          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="w-64 p-0" align="start">
                        <Command>
                          <CommandInput placeholder="Search batch files..." className="h-7 focus:outline-none" />
                          <CommandEmpty>No batch file found.</CommandEmpty>
                          <CommandList className="max-h-80 break-all">
                            {/* Today */}
                            <CommandGroup heading="Today">
                              {dropdownVal?.today?.map((file) => (
                                <CommandItem
                                  key={file.key}
                                  value={file.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  <span className='break-all'>{file?.name}</span>
                                </CommandItem>
                              ))}
                            </CommandGroup>

                            {/* Yesterday */}
                            <CommandGroup heading="Yesterday">
                              {dropdownVal?.yesterday.map((file) => (
                                <CommandItem
                                  key={file?.key}
                                  value={file?.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  {file.name}
                                </CommandItem>
                              ))}
                            </CommandGroup>

                            {/* This Week */}
                            <CommandGroup heading="This Week">
                              {dropdownVal?.thisWeek?.map((file) => (
                                <CommandItem
                                  key={file?.key}
                                  value={file?.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  {file?.name}
                                </CommandItem>
                              ))}
                            </CommandGroup>

                            {/* This Month */}
                            <CommandGroup heading="This Month">
                              {dropdownVal?.thisMonth?.map((file) => (
                                <CommandItem
                                  key={file?.key}
                                  value={file?.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  {file?.name}
                                </CommandItem>
                              ))}
                            </CommandGroup>
                            {/* Last Month */}
                            <CommandGroup heading="Last Month">
                              {dropdownVal?.lastMonth?.map((file) => (
                                <CommandItem
                                  key={file?.key}
                                  value={file?.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  {file?.name}
                                </CommandItem>
                              ))}
                            </CommandGroup>
                            <CommandGroup heading="Others">
                              {dropdownVal?.others?.map((file) => (
                                <CommandItem
                                  key={file.key}
                                  value={file.name}
                                  onSelect={() => {
                                    setSelectedBatchFile(file.name);
                                    setOpen(false);
                                  }}
                                >
                                  <Check
                                    className={`mr-2 h-4 w-4 ${selectedBatchFile === file.name ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                  {file?.name}
                                </CommandItem>
                              ))}
                            </CommandGroup>
                          </CommandList>
                        </Command>
                      </PopoverContent>
                    </Popover>
                  </div>
                  <Button
                    onClick={handleRunHarvest}
                    disabled={isRunning || !selectedBatchFile}
                    className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
                  >
                    {isRunning ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <Play className="w-4 h-4" />
                    )}
                    {isRunning ? 'Running chart review...' : 'Run '}
                  </Button>
                  {selectedBatchFile && <Button
                    variant="ghost"
                    onClick={() => handleDownloadPreBatch()}
                    title="Download Batch File"
                    className='border border-b'
                  >
                    {isDownloading ?
                      <Loader2 className=" h-4 w-4 animate-spin" />
                      :
                      <Download className="w-4 h-4" />
                    }
                  </Button>}
                </>
              )}
            </div>
            {
              //  <div className="flex items-center gap-3">
              //   <>
              //   <Select value={selectedCategory} onValueChange={setSelectedCategory}>
              //     <SelectTrigger className="w-[380px] truncate">
              //       <SelectValue className="capitalize" placeholder="Select Batch" />
              //     </SelectTrigger>
              //     <SelectContent className='h-[400px] overflow-y-auto'>
              //       {dropdownVal &&
              //         dropdownVal.map((value: any) => (
              //           <SelectItem key={value} value={value} className="capitalize overflow-hidden">
              //             {value}
              //           </SelectItem>
              //         ))}
              //     </SelectContent>
              //   </Select>
              //     <Button
              //       onClick={handleRunHarvest}
              //       disabled={isRunning || !selectedCategory}
              //       className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
              //     >
              //       {isRunning ? (
              //         <Loader2 className="w-4 h-4 animate-spin" />
              //       ) : (
              //         <Play className="w-4 h-4" />
              //       )}
              //       {isRunning ? 'Running Harvest...' : 'Run '}
              //     </Button></>
              //   {/* <Button variant="outline" size="sm" className='cursor-not-allowed opacity-[0.5]'>
              //     <Upload className="w-4 h-4 mr-2" />
              //     Export Report
              //   </Button> */}
              // </div>
            }
          </div>

          {/* KPI Cards */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-4 mb-8">
            <MetricCard
              title="Total Charts Scraped"
              value={kpiMetrics.totalCharts.toLocaleString()}
              icon={FileText}
              trend={kpiMetrics.trends.chartsScrapedTrend}
              description="Charts extracted from EMR systems"
            />
            <MetricCard
              title="Charts Passed AI Audit"
              value={kpiMetrics.chartsPassed.toLocaleString()}
              icon={CheckCircle}
              trend={kpiMetrics.trends.chartsPassedTrend}
              description="Charts meeting compliance criteria"
            />
            <MetricCard
              title="Charts Requiring Human Review"
              value={kpiMetrics.chartsNeedingReview.toLocaleString()}
              icon={Eye}
              trend={kpiMetrics.trends.chartsReviewTrend}
              description="Charts flagged for manual review"
            />
            <MetricCard
              title="Charts Failed Audit"
              value={kpiMetrics.chartsFailed.toLocaleString()}
              icon={AlertCircle}
              trend={kpiMetrics.trends.chartsFailedTrend}
              description="Charts not meeting compliance standards"
            />
            <MetricCard
              title="Average Scrape Duration"
              value={kpiMetrics.avgScrapeTime}
              icon={Database}
              trend={kpiMetrics.trends.scrapeTrend}
              description="Mean time for data extraction"
            />
            <MetricCard
              title="Average AI Evaluation Duration"
              value={kpiMetrics.avgAiTime}
              icon={Bot}
              trend={kpiMetrics.trends.aiTrend}
              description="Mean time for AI analysis"
            />
          </div> */}

          {/* Harvest Runs Table */}
          <Card className="bg-white/90 backdrop-blur-sm border-gray-200 shadow-lg">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-[16px]">
                <Activity className="w-5 h-5 text-blue-600" />
                Chart Review Details
              </CardTitle>
              <CardDescription className='text-[14px]'>
                {/* Last 10 charts extraction and AI evaluation runs. Click on completed runs to view detailed results. */}
                Recent batch summary with reviewed and pending charts.
              </CardDescription>
              {/* <div className="flex items-center gap-1 text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded w-fit">
                <MousePointer className="w-3 h-3" />
                <span>Click completed runs</span>
              </div> */}
            </CardHeader>
            <CardContent className="p-0">
              <div className="overflow-x-auto mx-6">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-gray-50 hover:bg-gray-50">
                      {tableHeaders.map((header, index) => {
                        if (header?.conditional === false) return null;
                        return (
                          <TableHead
                            key={index}
                            className={cn("font-inter text-sm font-medium text-gray-900", header?.className)}
                          >
                            <p className={cn("whitespace-normal break-words font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]", header?.lableClassName)}>
                              {header.label}
                            </p>
                          </TableHead>
                        );
                      })}
                    </TableRow>
                  </TableHeader>
                  <TableBody>

                    {
                      loading ? (
                        <TableRow>
                          <TableCell colSpan={10} className="text-center p-6">
                            Loading...
                          </TableCell>
                        </TableRow>
                      ) : harvestRuns?.length === 0 ? (
                        <TableRow>
                          <TableCell
                            colSpan={10}
                            className="p-12 text-center text-gray-600"
                          >
                            No batch found
                          </TableCell>
                        </TableRow>
                      ) : harvestRuns?.map((run: any) => {
                        return (
                          <TableRow
                            key={run?.id}
                            className={`transition-colors ${run?.status === 'COMPLETED'
                              ? 'hover:bg-blue-50 cursor-pointer'
                              : 'hover:bg-gray-50 cursor-not-allowed opacity-75'
                              }`}
                            onClick={() => {
                              if (hasChartPermission("chart:view")) { handleRowClick(run); }
                              else { toast.error("You need audit view permission to view details or contact your administrator"); }
                            }}
                            title={run?.status === 'COMPLETED' ? 'Click to view run details' : `Cannot view details for ${run.status.toLowerCase()} runs`}
                          >
                            <TableCell>
                              <code className="  py-1 rounded font-inter text-sm font-medium text-gray-600 flex gap-1">
                                {/* <span>{run?.harvest_file_name}</span> */}
                                <span>{run?.display_harvest_id || run?.run_id} </span>
                                <span>{run?.harvest_run_flag && run?.harvest_run_flag === 1 ? "(Test)" : ""} </span>
                              </code>
                            </TableCell>
                            <TableCell>
                              <code className="  py-1 rounded font-inter text-sm font-medium text-gray-600 flex gap-1">


                                <span>{new Date(run?.completed_at ?? run?.created_at ?? "")?.toLocaleDateString('en-US')}

                                </span>
                              </code>
                            </TableCell> <TableCell>
                              <code className="  py-1 rounded font-inter text-sm font-medium text-gray-600 flex gap-1">
                                <span>
                                  {new Date(run?.completed_at ?? run?.created_at ?? "")?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', })}
                                </span>
                              </code>
                            </TableCell>

                            {hasChartPermission("chart:create") && <TableCell>
                              <div className="flex flex-col gap-1 ">
                                {getStatusBadge(run?.status)}
                                {run?.status === 'In Progress' && (
                                  <Progress value={run?.progress} className="w-16 h-1" />
                                )}
                              </div>
                            </TableCell>}

                            {isAdmins && <TableCell>
                              <div className="flex flex-col">
                                <span className="text-gray-900 text-sm">
                                  {new Date(run?.updated_at)?.toLocaleDateString()}
                                </span>
                                <span className="text-gray-600 text-xs">
                                  {new Date(run?.updated_at)?.toLocaleTimeString()}
                                </span>
                              </div>
                            </TableCell>}

                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <span className="font-inter text-sm font-medium text-gray-600">{run?.chart_type}</span>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <span className="font-inter text-sm font-medium text-gray-600">{run?.total_charts}</span>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <div className={isAdmin ? "w-2 h-2 bg-yellow-500 rounded-full" : ""} />
                                {/* <span className="text-yellow-700 font-medium">{run?.charts_needs_review_count}</span> */}
                                <span className="text-yellow-500 font-inter text-sm font-medium"> {Number(run?.total_charts ?? 0) - (Number(run?.agreed_by_auditor ?? 0) + Number(run?.disagreed_by_auditor ?? 0))}</span>
                              </div>
                            </TableCell>

                            <TableCell className="text-center">
                              <div className="flex items-center justify-center gap-2">
                                <div className={isAdmin ? "w-2 h-2 bg-green-500 rounded-full" : ""} />
                                <span className="text-green-500 font-inter text-sm font-medium">
                                  {Number(run?.agreed_by_auditor ?? 0) + Number(run?.disagreed_by_auditor ?? 0)}
                                </span>
                              </div>
                            </TableCell>


                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-2">
                                {/* <div className="w-2 h-2 bg-yellow-500 rounded-full" /> */}
                                <span className="font-inter font-medium"> {Number(run?.total_charts ?? 0) - (Number(run?.agreed_by_auditor ?? 0) + Number(run?.disagreed_by_auditor ?? 0))}</span>
                              </div>
                            </TableCell>}
                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-2">
                                {/* <div className="w-2 h-2 bg-yellow-500 rounded-full" /> */}
                                <span className="font-inter font-medium">{run?.agreed_by_auditor}</span>
                              </div>
                            </TableCell>}
                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-2">
                                {/* <div className="w-2 h-2 bg-yellow-500 rounded-full" /> */}
                                <span className="font-inter font-medium">{run?.disagreed_by_auditor}</span>
                              </div>
                            </TableCell>}

                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-red-500 rounded-full" />
                                <span className="text-red-700 font-inter font-medium">{run?.charts_failed}</span>
                              </div>
                            </TableCell>}

                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-1">
                                <Database className="w-3 h-3 text-gray-400" />
                                <span className="text-gray-700 font-inter text-sm">
                                  {formatDuration(run?.scrape_time_seconds)}
                                </span>
                              </div>
                            </TableCell>}

                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-1">
                                <Bot className="w-3 h-3 text-gray-400" />
                                <span className="text-gray-700 font-inter text-sm">
                                  {formatDuration(run?.ai_time_seconds)}
                                </span>
                              </div>
                            </TableCell>}

                            {isAdmins && <TableCell>
                              <div className="flex items-center gap-1">
                                <Timer className="w-3 h-3 text-gray-400" />
                                <span className="text-gray-900 font-inter text-sm font-medium">
                                  {formatDuration(run?.total_time_seconds)}
                                </span>
                              </div>
                            </TableCell>}

                            {/* <TableCell>
                            <div className="flex items-center justify-center gap-4">
                              <Eye className="w-4 h-4 text-blue-500" />
                              {isAdmin && <div
                                className={`flex items-center justify-center ${run?.status === 'COMPLETED' ? 'cursor-pointer' : 'cursor-not-allowed opacity-75'
                                  }`}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  if (run?.status === 'COMPLETED') {
                                    handleDownload(run?.run_id);
                                  } else {
                                    toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                      description: 'Only completed harvest runs can be downloaded.',
                                    });
                                  }
                                }}
                                title={
                                  run?.status === 'COMPLETED'
                                    ? 'Click to download run details'
                                    : `Cannot download details for ${run?.status?.toLowerCase()} runs`
                                }
                              >
                                <Download className="w-4 h-4 text-blue-500" />
                              </div>}
                            </div>
                          </TableCell> */}
                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <span className="font-inter text-sm font-medium text-gray-600">{run?.kt_pending_count}</span>
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <span className="font-inter text-sm font-medium text-gray-600">{run?.updated_kantime_charts_count}</span>
                              </div>
                            </TableCell>

                            <TableCell>
                              <div className="flex items-center justify-center gap-2">
                                <span className="font-inter text-sm font-medium text-gray-600">{run?.noaction_kantime_charts_count}</span>
                              </div>
                            </TableCell>
                            <TableCell className='flex items-center justify-center'>
                              <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                  <Button
                                    variant="ghost"
                                    size="sm"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (!hasChartPermission("chart:create") && run?.status != 'COMPLETED') {
                                        toast.error(`Cannot View details for ${run?.status?.toLowerCase()} runs`, {
                                          description: 'Only chart details shown for completed runs.',
                                        })
                                      }
                                    }}
                                  >
                                    <MoreHorizontal className="w-4 h-4" />
                                  </Button>
                                </DropdownMenuTrigger>

                                {(hasChartPermission("chart:create") || run?.status === 'COMPLETED') && <DropdownMenuContent align="end" className="min-w-56 w-max">
                                  {run?.status === 'COMPLETED' && <DropdownMenuItem onClick={() => {
                                    if (run?.status === 'COMPLETED') {
                                      return;
                                    } else {
                                      toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                        description: 'Only completed batch runs can be downloaded.',
                                      });
                                    }
                                  }} className='cursor-pointer'>
                                    <Eye className="w-4 h-4 mr-2" />
                                    View
                                  </DropdownMenuItem>
                                  }
                                  {/* {isAdmin &&
                                  <> */}
                                  {hasChartPermission("chart:create") && (
                                    <>
                                      <DropdownMenuItem onClick={(e) => {
                                        e.stopPropagation();

                                        // if (run?.status === 'COMPLETED') {
                                        handleViewRunLog(run);
                                        // } else {
                                        //   toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                        //     description: 'Only completed batch runs can be downloaded.',
                                        //   });
                                        // }
                                      }} className='cursor-pointer'>
                                        <></>
                                        <FileText className="w-4 h-4 mr-2" />
                                        View Run Log
                                      </DropdownMenuItem>
                                      {/* </DropdownMenuItem> */}
                                      {/* if batch in run not able to re run batch */}
                                      {run?.status !== 'RUNNING' && <DropdownMenuItem onClick={(e) => {
                                        e.stopPropagation();
                                        // handleReTrychart(goal.id, goal?.chart_id);
                                        setSelectedBatchFile(run?.harvest_file_name);
                                        setShowRunDialog(true);
                                        // console.log(run, "run")

                                      }}>
                                        <></>
                                        <RotateCcw className="w-4 h-4 mr-2 color-blue" />
                                        Re-Run Batch
                                      </DropdownMenuItem>}

                                      <DropdownMenuItem onClick={(e) => {
                                        e.stopPropagation();

                                        // if (run?.status === 'COMPLETED') {
                                        handleDownload(run?.run_id);
                                        // } else {
                                        //   toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                        //     description: 'Only completed chart review runs can be downloaded.',
                                        //   });
                                        // }
                                      }} className='cursor-pointer'>
                                        <></>
                                        <Download className="w-4 h-4 mr-2" />
                                        Chart Download
                                      </DropdownMenuItem>
                                      {run?.status === 'COMPLETED' && <DropdownMenuItem onClick={(e) => {
                                        e.stopPropagation();

                                        if (run?.status === 'COMPLETED') {
                                          handleBatchDownload(run?.run_id, run?.display_harvest_id, run?.harvest_run_flag);
                                        } else {
                                          toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                            description: 'Only completed batch runs can be downloaded.',
                                          });
                                        }
                                      }} className='cursor-pointer'>
                                        <></>
                                        <Download className="w-4 h-4 mr-2" />
                                        Batch Download
                                      </DropdownMenuItem>}
                                      <DropdownMenuItem
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleDownloadLog(run?.display_harvest_id);
                                        }}
                                        className='cursor-pointer'>
                                        <Download className="w-4 h-4 mr-2" />
                                        Download View Log
                                      </DropdownMenuItem>
                                      <DropdownMenuItem onClick={(e) => {
                                        e.stopPropagation();
                                        handleArchiveBatch(run?.id);
                                      }} className='cursor-pointer'>
                                        {run?.archive ? (<ArchiveRestore className="w-4 h-4 mr-2" />) :
                                          (<Archive className="w-4 h-4 mr-2" />)}
                                        {run?.archive ? "Unarchive" : "Archive"}
                                      </DropdownMenuItem>
                                      {(run?.status === 'COMPLETED' || run?.status === 'PARTIAL') &&
                                        <>

                                          {hasChartPermission("audits:review") && (
                                            <>

                                              {run?.harvest_run_flag === 2 && <>

                                                <DropdownMenuSeparator />
                                                {/* <DropdownMenuItem onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedHarvestRunData(run?.id)
                                                setCurrentView('kan-time-update')
                                              }}>
                                                <SquareArrowUp className='w-4 h-4 mr-2' />
                                                {`Update ${orgConfig.name}`}
                                              </DropdownMenuItem> */}
                                                {run?.harvest_run_status !== "Approved" ?
                                                  <DropdownMenuItem onClick={(e) => { e.stopPropagation(); setSelectedRun(run) }} className='bg-green-500 text-white hover:!bg-green-600 hover:!text-white cursor-pointer transition-colors whitespace-nowrap'>

                                                    <CircleCheckBig className="w-4 h-4 mr-2 text-white shrink-0" />
                                                    Send to Audit Queue
                                                  </DropdownMenuItem>
                                                  : run?.harvest_run_status === "Approved" ?
                                                    <DropdownMenuItem
                                                      onClick={(e) => {

                                                        e.stopPropagation();
                                                        setSelectedRun(run);

                                                      }}
                                                      className="bg-gray-400 text-white hover:!bg-gray-500 hover:!text-white cursor-pointer transition-colors whitespace-nowrap"
                                                    >
                                                      <Undo className="w-4 h-4 mr-2 text-white shrink-0" />
                                                      Return from Audit Queue
                                                    </DropdownMenuItem> : null}
                                              </>}

                                              {/* <DropdownMenuSeparator /> */}
                                              {/* <DropdownMenuItem onClick={(e) => {
                                                e.stopPropagation();

                                                if (run?.status === 'COMPLETED') {
                                                  // handleBatchDownload(run?.run_id, run?.display_harvest_id,run?.harvest_run_flag);
                                                  handleComparePerformance(run);
                                                } else {
                                                  toast.error(`Cannot download details for ${run?.status?.toLowerCase()} runs`, {
                                                    description: 'Only completed batch runs can be downloaded.',
                                                  });
                                                }
                                              }} className='cursor-pointer text-blue-600'>
                                                <></>
                                                <ChartColumn className="w-4 h-4 mr-2" />
                                                Compare Performance
                                              </DropdownMenuItem> */}
                                            </>
                                          )}
                                        </>}
                                    </>)}
                                </DropdownMenuContent>}
                              </DropdownMenu>
                            </TableCell>
                            {/* {isAdmin && <TableCell className='text-center'>
                            <Button onClick={(e) => {
                              e.stopPropagation();
                              // handleApproveHarvest(run?.run_id)
                              setSelectedRun(run)
                            }} className="text-sm bg-blue-600 hover:bg-blue-700 max-w-32">
                              <p className='text-sm'>Approve</p>
                            </Button>
                          </TableCell>} */}


                          </TableRow>
                        )
                      }
                      )}
                  </TableBody>
                </Table>
                {totalPages > 1 && (
                  <div className="px-6 py-4 border-t bg-gray-50">
                    <div className="flex justify-between items-center">
                      {/* <span className="text-sm text-gray-600">
                        Showing {totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} results
                      </span> */}

                      <PaginationCustom
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onItemsPerPageChange={(newItemsPerPage) => {
                          onPageChange(1); // Reset page to 1
                        }}
                      // showPageSizeSelector={false}  // ❌ Hides "items per page"
                      // showItemCount={false}         // ✅ Because we manually show the count above
                      />
                    </div>
                  </div>



                )}
              </div>
            </CardContent>
          </Card>

          {/* Run Harvest Confirmation Dialog */}
          <AlertDialog open={showRunDialog} onOpenChange={setShowRunDialog}>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle className="flex items-center gap-2">
                  <Play className="w-5 h-5 text-blue-600" />
                  Run New Chart Review
                </AlertDialogTitle>
                <AlertDialogDescription>
                  This will initiate a new chart review run that will:
                  <ul className="list-disc list-inside mt-2 space-y-1">
                    <li>Extract chart data from connected EMR systems</li>
                    <li>Process extracted data through AI evaluation pipeline</li>
                    <li>Generate compliance audit results</li>
                    <li>Flag charts requiring human review</li>
                  </ul>
                  <div className="mt-4 p-3 bg-blue-50 rounded-lg">
                    <p className="text-blue-800  text-sm">
                      <strong>Estimated Duration:</strong> 5-15 minutes depending on chart volume
                    </p>
                  </div>
                </AlertDialogDescription>
              </AlertDialogHeader>
              <div className='flex justify-between items-center'>
                <div className='flex items-center gap-1 h-10 justify-center'>
                  <Checkbox
                    // checked={typeOfRun === 1}
                    onCheckedChange={(checked) => {
                      setTypeOfRun(checked === true ? 1 : 2)
                    }} />
                  <div className="font-semibold text-sm text-gray-800 ml-1">Test Run</div>

                </div>
                <AlertDialogFooter>
                  <AlertDialogCancel onClick={() => setSelectedBatchFile(null)}>Cancel</AlertDialogCancel>
                  <AlertDialogAction
                    onClick={confirmRunHarvest}
                    className="bg-blue-600 hover:bg-blue-700"
                  >
                    <Play className="w-4 h-4 mr-2" />
                    Start Chart Review Run
                  </AlertDialogAction>

                </AlertDialogFooter>
              </div>
            </AlertDialogContent>
          </AlertDialog>

          {/* Approve Run Confirmation Popup */}
          <Dialog open={selectedRun} onOpenChange={() => setSelectedRun(null)}>
            <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
              <DialogHeader className='gap-y-5'>
                <DialogTitle>Audit Batch-ID: {selectedRun?.display_harvest_id}</DialogTitle>
                <DialogDescription>
                  {`Are you sure you want to ${selectedRun?.harvest_run_status === 'Approved' ? 'return from audit queue' : 'send to audit queue'} this Batch ID?`}
                </DialogDescription>
              </DialogHeader>

              {/* {selectedGoal && (
                  <div className="space-y-6">
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <Target className="w-4 h-4" />
                          {selectedGoal?.section} - Healthcare Goal Detail
                        </CardTitle>
                      </CardHeader>
                      <CardContent className="space-y-4">
                        <div>
                          <p className="text-gray-600 text-sm mb-2">Goal Task</p>
                          <p className="text-gray-900">{selectedGoal?.goalTask.full}</p>
                        </div>

                        <Separator />

                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <p className="text-gray-600 text-sm mb-2">Action Taken</p>
                            <Badge variant="outline" className={getActionColor(selectedGoal?.action)}>
                              {selectedGoal.action}
                            </Badge>
                          </div>
                          <div>
                            <p className="text-gray-600 text-sm mb-2">Decision</p>
                            <Badge variant="outline" className={getDecisionColor(selectedGoal.decision)}>
                              {selectedGoal.decision}
                            </Badge>
                          </div>
                        </div>

                        <Separator />

                        <div>
                          <p className="text-gray-600 text-sm mb-2">Detailed Notes</p>
                          <div className="bg-gray-50 p-3 rounded-lg">
                            <p className="text-gray-900">{selectedGoal.notes.full}</p>
                          </div>
                        </div>

                        <div>
                          <p className="text-gray-600 text-sm mb-2">AI Suggestion</p>
                          <div className="bg-blue-50 p-3 rounded-lg">
                            <p className="text-blue-900">{selectedGoal.suggestion.full}</p>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <p className="text-gray-600 text-sm mb-2">AI Score</p>
                            <p className="font-medium">{selectedGoal.confidenceScore}%</p>
                          </div>
                          <div>
                            <p className="text-gray-600 text-sm mb-2">Category</p>
                            <p className="font-medium">{selectedGoal.category}</p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                )} */}

              <DialogFooter>
                <Button variant="outline" onClick={() => setSelectedRun(null)}>
                  Close
                </Button>
                <Button variant="approve" onClick={() => selectedRun?.harvest_run_status === 'Approved' ? hanldeUnApproeveHarvest(selectedRun?.run_id) : handleApproveHarvest(selectedRun?.run_id)}>
                  {`${selectedRun?.harvest_run_status === 'Approved' ? 'Return from Audit Queue' : 'Send to Audit Queue'}`}
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
          <Dialog open={updateKT} onOpenChange={() => setUpdateKT(false)}>
            <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
              <DialogHeader className='gap-y-5'>
                <DialogTitle>Update KanTime</DialogTitle>
                <DialogDescription>
                  Are you sure you want to Update KanTime Status?
                </DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button variant="outline" onClick={() => setUpdateKT(false)}>
                  Close
                </Button>
                <Button variant="approve" onClick={handleUpdateKantTime}>
                  Update
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </Layout>
  );
}